import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/product-offerings/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Full absolute strings (RR6 requires a child's path to start with its parent's).
 */
export const globalProductOfferingsRoute = defineRoute("/libraries/product-offerings");
export const productOfferingRoute = defineRoute("/libraries/product-offerings/:idOrAdd");
export const productOfferingCreateRoute = defineRoute("/libraries/product-offerings/add");
export const productOfferingEditRoute = defineRoute("/libraries/product-offerings/edit/:productOfferingId/:rpavId");
export const productOfferingScopeRoute = defineRoute("/libraries/product-offerings/:productOfferingId/scope/:rpavId");
export const productOfferingCostCalculatorRoute = defineRoute(
  "/libraries/product-offerings/:productOfferingId/cost-calculator/:rpavId",
);
export const productOfferingCheckoutStartingConfigRoute = defineRoute(
  "/libraries/product-offerings/:productOfferingId/checkout-starting-config/:rpavId",
);
export const productOfferingConfigPricingTraceRoute = defineRoute(
  "/libraries/product-offerings/checkout-pricing-trace/:configId",
);
